import { CtaButton, CtaButton2 } from "@/app/lib/Button";
import Image from "next/image";

export default function Slide3() {
  return (
    <div className="relative w-full h-[862px] lg:h-[504px] flex items-start lg:items-center justify-center overflow-hidden py-[54px] lg:py-[56px] px-[16px] lg:px-[56px]">
      <Image
        src="/slide3_bg.webp"
        alt="CFA preparation banner"
        fill
        priority
        className="object-cover"
        sizes="(max-width: 1024px) 100vw, 70vw"
      />
      <div className="absolute inset-0 bg-[#0a1324]/45" />
      <div className="relative flex flex-col gap-[32px] lg:gap-[40px] justify-center items-center lg:items-start">
        <div className="flex flex-col gap-[8px] lg:gap-[16px] w-auto lg:max-w-[780px]">
          <div className="bg-white px-[20px] py-[12px] rounded-[12px] text-center">
            <h2 className="text-[48px] md:text-[61px] font-[600] leading-[100%]">
              Prepare with Purpose. <br /> Pass with{" "}
              <span className="text-primary">Confidence.</span>
            </h2>
          </div>
          <div>
            <h4 className="font-[600] text-[32px] md:text-[36px] text-[#E4E4E4] leading-[100%] text-center lg:text-left">
              A rigorous, intuition-driven CFA® prep program designed to support
              you every step of the way.
            </h4>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-[12px] w-full md:w-auto items-center">
            <div className="w-full md:w-auto">
              <CtaButton text={"Start Learning Now"} />
            </div>
            <div className="w-full md:w-auto">
              <CtaButton2 text={"UPCOMING BATCHES"} />
            </div>
          </div>
      </div>
    </div>
  );
}
